export function hasFlexibleHeight(id, state) {
    return !!(state.CheckboxList[id] ||
        state.RadioList[id] ||
        (state.ButtonBar[id] && state.ButtonBar[id].orientation === 'vertical'));
}
